import React from "react";
import {
    ApartmentOutlined,
    AppstoreOutlined,
    CalendarOutlined,
    CheckCircleOutlined,
    ClusterOutlined,
    CodeOutlined,
    ContainerOutlined,
    ControlOutlined,
    CreditCardOutlined,
    DollarCircleOutlined,
    EnvironmentOutlined,
    ExportOutlined,
    FileDoneOutlined,
    FileImageOutlined,
    FileSyncOutlined,
    FlagOutlined,
    GoogleOutlined,
    HistoryOutlined,
    HomeOutlined,
    InteractionOutlined,
    MacCommandOutlined,
    PercentageOutlined,
    PhoneOutlined,
    ProfileOutlined,
    ScheduleOutlined,
    TableOutlined,
    TeamOutlined,
    UserAddOutlined,
    UsergroupAddOutlined,
    UserOutlined
} from "@ant-design/icons";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";
import {
    Form,
    Drawer,
    Divider,
    InputDate,
    Card,
    Badge,
    Tabs,
    Button,
    Spin,
    Col,
    Row,
    Table,
    ArrowLeftOutlined
} from "common/elements";
import "./view-profile.css";
import {
    getProfile,
    getEmployeeCertificates,
    markAsPassedProbation,
    getEmployeeBenefits,
    getEmployeeHistory,
    getEmployeesLeave,
} from "services/employee";
import { Util } from "common/util";
import Enum from "common/enums";
import { getHostURl } from "services/core";

function ConfirmProbationDrawer({ employeeId, type, probationEndDate, onReload,data }) {
    const [visible, setVisible] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [form] = Form.useForm();
    const onShow = () => {
        setVisible(true);
    };

    const onCancel = () => {
        setVisible(false);
    };

    const onApply = () => {
        form.validateFields(["probationEndDate"])
            .then((values) => {
                swal({
                    title: "Confirmation",
                    text: "Are you sure you want to confirm that the employee has successfully passed their probation period and is now a permanent employee?",
                    icon: "warning",
                    buttons: ["No", "Yes"],
                })
                    .then((confirmed) => {
                        if (confirmed) {
                            setSubmitting(true);
                            markAsPassedProbation(employeeId, moment(values.probationEndDate).format("YYYY-MM-DD"))
                                .then(() => {
                                    swal({
                                        title: "Congratulations!",
                                        text: "You have successfully confirmed that the employee has passed their probation period and is now a permanent employee. We appreciate their hard work and dedication to our company. Thank you!",
                                        icon: "success",
                                        button: "OK",
                                    })
                                        .then(() => {
                                            onReload();
                                        });
                                })
                                .finally(() => {
                                    setSubmitting(false);
                                    setVisible(false);
                                });
                        } else {
                            swal("Cancelled", "You have cancelled the confirmation process.", "error");
                        }
                    });
            });
    };

    const onClose = () => {
        setVisible(false);
    };
    return (
        <>
            {type === "PERMANENT_STAFF" ?
                <Badge
                    className="site-badge-count-109"
                    count={"Passed Probation"}
                    style={{
                        backgroundColor: '#52c41a',
                    }}
                />
                :

                data?.id !== Util.getInstance().getAuthSession().profile.id && <Button onClick={onShow}>Confirm Probation</Button>
                
            }

            <Drawer
                title={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Button onClick={onCancel}>Cancel</Button>
                        <div>Filter</div>
                        <Button loading={submitting} type="primary" onClick={onApply}>Apply</Button>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={onClose}
                visible={visible}
            >
                <Form form={form}>
                    <InputDate
                        name="probationEndDate"
                        initialValue={probationEndDate ? moment(probationEndDate) : null}
                        label="Probation End Date"
                        format="DD/MM/YYYY"
                        required={true}
                        errorMessage="Please select probation end date"
                        style={{ width: "100%", marginLeft: 0, marginTop: 0 }}
                    />
                </Form>
            </Drawer>
        </>
    );
}

const ViewProfile = ({ employeeId }) => {
    const [loading, setLoading] = React.useState(true);
    const [loadingHistory, setLoadingHistory] = React.useState(false);
    const [loadingLeave, setLoadingLeave] = React.useState(false);
    const [data, setData] = React.useState({ branch: {}, user: {}, permissions: [], department: {}, supervisor: {}, team: {}, employeeBenefits: [] });
    const [employeeBenefits, setEmployeeBenefits] = React.useState([]);
    const [employeeCertifications, setEmployeeCertifications] = React.useState([]);
    const [employeeGrossSalary, setEmployeeGrossSalary] = React.useState([]);
    const [employeePensionFund, setEmployeePensionFund] = React.useState([]);
    const [employeeProvidentFund, setEmployeeProvidentFund] = React.useState([]);
    const [employeePosition, setEmployeePosition] = React.useState([]);
    const [employeeJobGrade, setEmployeeJobGrade] = React.useState([]);
    const [switchTopFilter, setSwitchTopFilter] = React.useState("Overview");
    const [employeeLeave, setEmployeeLeave] = React.useState([]);
    const navigate = useNavigate();
    let { id } = useParams();
    id = id ? id : employeeId;

    const { TabPane } = Tabs;

    React.useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        getProfile(id)
            .then(response => {
                if (response.data) {
                    setData(response.data);
                }
            })
            .finally(() => setLoading(false));

        getEmployeeCertificates(id).then((response) => {
            if (response.data) {
                setEmployeeCertifications(response.data)
            }
        });
        getEmployeeBenefits(id).then((response) => {
            if (response.data) {
                setEmployeeBenefits(response.data)
            }
        });
    }

    const onBack = () => {
        navigate("/employees");
    };

    const goToEdit = () => {
        navigate(`/employees/update/${id}`);
    }

    const onChangeTopFilter = (value) => {
        if (value === "Overview") {
            setSwitchTopFilter("Overview")
        } else if (value === "History") {
            setSwitchTopFilter("History")
            setLoadingHistory(true);
            getEmployeeHistory(id, "GROSS_SALARY").then((response) => {
                if (response.data.data) {
                    setEmployeeGrossSalary(response.data.data);
                }
            }).finally(() => setLoadingHistory(false));
        } else {
            setLoadingLeave(true)
            setSwitchTopFilter("Leave-Balance")
            getEmployeesLeave(id).then((response) => {
                if (response) {
                    setEmployeeLeave(response);
                }
            }).finally(() => setLoadingLeave(false));
        }
    }

    const onChangeHistory = (key) => {
        if (key === "gross-salary") {
            setLoadingHistory(true);
            getEmployeeHistory(id, "GROSS_SALARY").then((response) => {
                if (response.data.data) {
                    setEmployeeGrossSalary(response.data.data);
                }
            }).finally(() => setLoadingHistory(false));
        } else if (key === "pension-fund") {
            setLoadingHistory(true);
            getEmployeeHistory(id, "PENSION_FUND").then((response) => {
                if (response.data.data) {
                    setEmployeePensionFund(response.data.data);
                }
            }).finally(() => setLoadingHistory(false));
        }
        else if (key === "provident-fund") {
            setLoadingHistory(true);
            getEmployeeHistory(id, "PROVIDEND_FUND").then((response) => {
                if (response.data.data) {
                    setEmployeeProvidentFund(response.data.data);
                }
            }).finally(() => setLoadingHistory(false));
        }
        else if (key === "position") {
            setLoadingHistory(true);
            getEmployeeHistory(id, "POSITION").then((response) => {
                if (response.data.data) {
                    setEmployeePosition(response.data.data);
                }
            }).finally(() => setLoadingHistory(false));
        } else {
            setLoadingHistory(true);
            getEmployeeHistory(id, "JOB_GRADE").then((response) => {
                if (response.data.data) {
                    setEmployeeJobGrade(response.data.data);
                }
            }).finally(() => setLoadingHistory(false));
        }
    }

    const getLeaveTypeName = (leaveType, value, column) => {
        switch (leaveType) {
            case Enum.LEAVE_TYPE.ANNUAL_LEAVE:
                return `${value} days`;
            case Enum.LEAVE_TYPE.SICK_LEAVE:
                return column === "taken" ? `${value} days` : "";
            case Enum.LEAVE_TYPE.MATERNITY:
                return ["entilement", "taken", "balance"].includes(column) ? `${value} weeks` : "";
            case Enum.LEAVE_TYPE.PATERNITY_LEAVE:
                return ["entilement", "taken", "balance"].includes(column) ? `${value} weeks (x${value})` : "";
            case Enum.LEAVE_TYPE.SPECIAL_LEAVE:
                return ["entilement", "taken", "balance"].includes(column) ? `${value} days` : "";
            case Enum.LEAVE_TYPE.UNPAID_LEAVE:
                return column === "taken" ? `${value} days` : "";
            case Enum.LEAVE_TYPE.COMPENSATION:
                return ["taken", "balance"].includes(column) ? `${value} days` : "";
            case Enum.LEAVE_TYPE.JOB_SEEKING_LEAVE:
                return ["taken", "balance"].includes(column) ? `${value} days` : "";
            default:
                return '';
        }
    }

    return (
        <Spin spinning={loading}>
            <div className="btn-navigation">
                <Row>
                    <Col span={12}>
                        <div className="pull-left">
                            <Button onClick={onBack}>
                                <ArrowLeftOutlined />
                                {t("text_back")}
                            </Button>
                            <span className="title">
                                {t("text_employee_profile")}
                            </span>
                        </div>
                    </Col>
                </Row>
            </div>
            <div style={{ height: "85vh", overflowY: "auto", background: "#EFF3F6", padding: "0 8px" }}>
                <div className="card-layout" style={{ marginBottom: 47, marginTop: 20, height: 230 }}>
                    <Row style={{ height: "100%", width: "100%" }} >
                        <Col span={24}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "100%", padding: "0 37.28px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    {
                                        data.user.photo ?
                                            <img
                                                src={`${getHostURl()}/public/uploads/profile/${data.user.photo}?v=${Date.now()}`}
                                                alt="Logo"
                                                style={{ height: 118, width: 118, borderRadius: "100%", objectFit: "cover" }}
                                            /> :
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 118, width: 118, borderRadius: "100%", background: "#8F989F" }}>
                                                <span style={{ fontWeight: 600, fontSize: 32, color: "#000000" }}>{data.name && Util.getInstance().getFristCharater(data.name)}</span>
                                            </div>
                                    }

                                    <div style={{ marginLeft: 37.28, display: "flex", flexDirection: "column" }}>
                                        <div style={{ fontWeight: 600, fontSize: 32, color: "#000000" }}>
                                            {data.name}
                                        </div>
                                        <div style={{ fontWeight: 400, fontSize: 17, color: "#000000", display: "flex", }}>
                                            Position <div style={{ display: "flex", alignItems: "center", margin: "0 7px" }}><span style={{ width: 5, height: 5, background: "#000000", borderRadius: "100%", }}></span></div> {data.position ? data.position : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {
                                        Util.getInstance().hasPermission("confirm probation", "employee") &&
                                        <ConfirmProbationDrawer
                                            type={data.type}
                                            data={data}
                                            probationEndDate={data.probationExpiredDate}
                                            employeeId={id}
                                            onReload={fetchData}
                                        />
                                    }
                                    {
                                        Util.getInstance().hasPermission("edit", "employee") &&
                                        <Button type="primary" style={{ marginLeft: 25 }} onClick={(goToEdit)}>
                                            <span>
                                                {t("text_edit")}
                                            </span>
                                        </Button>
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col span={24}>
                            <div style={{ display: "flex", padding: "18.8px 0px 0px 37.28px " }}>
                                <div className={switchTopFilter === "Overview" ? "button-employee-file-tab-active" : "button-employee-file-tab"} onClick={() => onChangeTopFilter("Overview")}>
                                    <AppstoreOutlined /> <span style={{ marginLeft: 10.69 }}>Overview</span>
                                </div>
                                <div className={switchTopFilter === "History" ? "button-employee-file-tab-active" : "button-employee-file-tab"} onClick={() => onChangeTopFilter("History")}>
                                    <HistoryOutlined /><span style={{ marginLeft: 10.69 }}>History</span>
                                </div>
                                <div className={switchTopFilter === "Leave-Balance" ? "button-employee-file-tab-active" : "button-employee-file-tab"} onClick={() => onChangeTopFilter("Leave-Balance")}>
                                    <ExportOutlined /><span style={{ marginLeft: 10.69 }}>Leave Balance</span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                {
                    switchTopFilter === "Overview" &&
                    <>
                        <Card title={t("text_personal_information")} bordered={false} className="employee-form title-font" style={{ marginBottom: 32 }}>
                            <Row gutter={[8, 40]}>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <TableOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.code ? data.code : "N/A"}</span>
                                            <span className="decription-title">{t("text_employee_id")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UserOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.name ? data.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_full_name")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8} >
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UserOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.namekh ? data.namekh : "N/A"}</span>
                                            <span className="decription-title">{t("text_full_name_kh")}</span>
                                        </div>
                                    </div>
                                </Col>

                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UserAddOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.gender === Enum.GENDER.MALE ? "Male" : data.gender === Enum.GENDER.FEMALE ? "Female" : data.gender === Enum.GENDER.OTHER ? t("text_other") : "N/A"}</span>
                                            <span className="decription-title">{t("text_gender")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UsergroupAddOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.maritalStatus ? data.maritalStatus : "N/A"}</span>
                                            <span className="decription-title">{t("text_marital_status")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8} >
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <EnvironmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.address ? data.address : "N/A"}</span>
                                            <span className="decription-title">{t("text_current_address")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.dob ? moment(data.dob).format("DD/MM/YYYY") : "N/A"}</span>
                                            <span className="decription-title">{t("text_date_of_birth")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <HomeOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.placeOfBirth ? data.placeOfBirth : "N/A"} </span>
                                            <span className="decription-title">{t("text_place_of_birth")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8} >
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <FlagOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.nationality?.name ? data.nationality.name : "N/A"}</span>
                                            <span className="decription-title">{t("text_nationality")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <FlagOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.religious ? data.religious : "N/A"}</span>
                                            <span className="decription-title">{t("text_religious")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.nationIDNumber ? data.nationIDNumber : "N/A"}</span>
                                            <span className="decription-title">{t("text_national_id_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8} >
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">
                                                {
                                                    (moment().format("YYYY-MM-DD") > moment(data.expiredDate).format("YYYY-MM-DD")) ?
                                                        <Badge count={"expired"}
                                                            style={{
                                                                backgroundColor: "#FF3636",
                                                                position: "absolute",
                                                                top: -6,
                                                                right: -23
                                                            }}
                                                        >
                                                            <span className="decription">{data.expiredDate ? moment(data.expiredDate).format("DD/MM/YYYY") : "N/A"}</span>
                                                        </Badge>
                                                        :
                                                        <> {data.expiredDate ? moment(data.expiredDate).format("DD/MM/YYYY") : "N/A"}</>
                                                }
                                            </span>
                                            <span className="decription-title">{t("text_expired_date")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_passport_information")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ContainerOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.passportType?.name ? data.passportType.name : "N/A"}</span>
                                            <span className="decription-title">{t("text_passport_type")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.passportNumber ? data.passportNumber : "N/A"} </span>
                                            <span className="decription-title">{t("text_passport_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8} >
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.passportIssuedDate ? moment(data.passportIssuedDate).format("DD/MM/YYYY") : "N/A"}</span>
                                            <span className="decription-title">{t("text_date_of_issued")}</span>
                                        </div>
                                    </div>
                                </Col>

                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <EnvironmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.passportIssuedPlace ? data.passportIssuedPlace : "N/A"}</span>
                                            <span className="decription-title">{t("text_place_of_issued")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">
                                                {
                                                    (moment().format("YYYY-MM-DD") > moment(data.passportExpiredDate).format("YYYY-MM-DD")) ?
                                                        <Badge count={"expired"}
                                                            style={{
                                                                backgroundColor: "#FF3636",
                                                                position: "absolute",
                                                                top: -6,
                                                                right: -23
                                                            }}
                                                        >
                                                            <span className="decription">{data.passportExpiredDate ? moment(data.passportExpiredDate).format("DD/MM/YYYY") : "N/A"}</span>
                                                        </Badge>
                                                        :
                                                        <> {data.passportExpiredDate ? moment(data.passportExpiredDate).format("DD/MM/YYYY") : "N/A"}</>
                                                }
                                            </span>
                                            <span className="decription-title">{t("text_expired_date")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_visa_information")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ContainerOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.visaType?.name ? data.visaType?.name : "N/A"}</span>
                                            <span className="decription-title">{t("text_visa_type")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.visaNumber ? data.visaNumber : "N/A"} </span>
                                            <span className="decription-title">{t("text_visa_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8} >
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">
                                                {
                                                    (moment().format("YYYY-MM-DD") > moment(data.visaExpiredDate).format("YYYY-MM-DD")) ?
                                                        <Badge count={"expired"}
                                                            style={{
                                                                backgroundColor: "#FF3636",
                                                                position: "absolute",
                                                                top: -6,
                                                                right: -23
                                                            }}
                                                        >
                                                            <span className="decription">{data.visaExpiredDate ? moment(data.visaExpiredDate).format("DD/MM/YYYY") : "N/A"}</span>
                                                        </Badge>
                                                        :
                                                        <> {data.visaExpiredDate ? moment(data.visaExpiredDate).format("DD/MM/YYYY") : "N/A"}</>
                                                }
                                            </span>
                                            <span className="decription-title">{t("text_expired_date")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_spouse_and_kids_information")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ContainerOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.spouseName ? data.spouseName : "N/A"}</span>
                                            <span className="decription-title">{t("text_spouse_name")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.spouseWorkingStatus === 0 ? t("text_No") : data.spouseWorkingStatus === 1 ? t("text_yes") : "N/A"} </span>
                                            <span className="decription-title">{t("text_visa_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.spouseOccupation ? data.spouseOccupation : "N/A"} </span>
                                            <span className="decription-title">{t("text_occupation")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table" >
                                        <Table
                                            rowKey={() => `kids${Date.now() + Math.random()}`}
                                            dataSource={data.kids}
                                            columns={[
                                                {
                                                    title: t("text_kid_name"),
                                                    dataIndex: "name",
                                                    height: 60,
                                                    key: "name",
                                                    render: (name) => name ? name : "N/A"
                                                },
                                                {
                                                    title: t("text_date_of_birth"),
                                                    dataIndex: "dob",
                                                    key: "dob",
                                                    width: 251,
                                                    render: (dob) => dob ? Util.getInstance().formatDate(dob) : "N/A"
                                                },
                                                {
                                                    title: t("text_age"),
                                                    dataIndex: "age",
                                                    key: "age",
                                                    render: (age, record) => record.dob ? moment().diff(record.dob, 'years') : "N/A"
                                                },
                                                {
                                                    title: t("text_current_status"),
                                                    dataIndex: "currentStatus",
                                                    key: "currentStatus",
                                                    render: (currentStatus) => currentStatus === "UNDER_CONTROLL" ? t("text_under_controll") : currentStatus === "OUT_OF_CONTROLL" ? t("text_out_of_controll") : "N/A"
                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_sibling_parents_and_other_information")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UserOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.motherName ? data.motherName : "N/A"} </span>
                                            <span className="decription-title">{t("text_mother_name")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8} >
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UserOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.fatherName ? data.fatherName : "N/A"}</span>
                                            <span className="decription-title">{t("text_father_name")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table" >
                                        <Table
                                            rowKey={() => `kids${Date.now() + Math.random()}`}
                                            dataSource={data.siblings}
                                            columns={[
                                                {
                                                    title: t("text_kid_name"),
                                                    dataIndex: "name",
                                                    height: 60,
                                                    key: "name",
                                                    render: (name) => name ? name : "N/A"
                                                },
                                                {
                                                    title: t("text_date_of_birth"),
                                                    dataIndex: "dob",
                                                    key: "dob",
                                                    width: 251,
                                                    render: (dob) => dob ? Util.getInstance().formatDate(dob) : "N/A"
                                                },
                                                {
                                                    title: t("text_age"),
                                                    dataIndex: "age",
                                                    key: "age",
                                                    render: (age, record) => record.dob ? moment().diff(record.dob, 'years') : "N/A"
                                                },
                                                {
                                                    title: t("text_current_status"),
                                                    dataIndex: "currentStatus",
                                                    key: "currentStatus",
                                                    render: (currentStatus) => currentStatus === "UNDER_CONTROLL" ? t("text_under_controll") : currentStatus === "OUT_OF_CONTROLL" ? t("text_out_of_controll") : "N/A"
                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.nssfNumber ? data.nssfNumber : "N/A"} </span>
                                            <span className="decription-title">{t("text_nssf_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.workbookNumber ? data.workbookNumber : "N/A"} </span>
                                            <span className="decription-title">{t("text_workbook_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CreditCardOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.workPermitNumber ? data.workPermitNumber : "N/A"} </span>
                                            <span className="decription-title">{t("text_workpermit_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_next_of_king_information")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table" >
                                        <Table
                                            rowKey={() => `inheritances${Date.now() + Math.random()}`}
                                            dataSource={data.inheritances}
                                            columns={[
                                                {
                                                    title: t("text_name"),
                                                    dataIndex: "name",
                                                    key: "name",
                                                    render: (name) => name ? name : "N/A"

                                                },
                                                {
                                                    title: t("text_national_id_number"),
                                                    dataIndex: "idCard",
                                                    key: "idCard",
                                                    render: (idCard) => idCard ? idCard : "N/A"
                                                },
                                                {
                                                    title: t("text_inheritance"),
                                                    dataIndex: "percentage",
                                                    key: "percentage",
                                                    render: (percentage) => percentage ? `${percentage}%` : "N/A"
                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                        <Card title={t("text_contacts_information")} bordered={false} className="employee-form title-font" style={{ marginBottom: 32 }}>
                            <Row gutter={[8, 40]}>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <PhoneOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.contactNumber ? data.contactNumber : "N/A"} </span>
                                            <span className="decription-title">{t("text_contact_number_1")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <PhoneOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.contactNumber2 ? data.contactNumber2 : "N/A"} </span>
                                            <span className="decription-title">{t("text_contact_number_2")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <PhoneOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.contactNumber3 ? data.contactNumber3 : "N/A"} </span>
                                            <span className="decription-title">{t("text_contact_number_3")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <GoogleOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.email ? data.email : "N/A"} </span>
                                            <span className="decription-title">{t("text_personal_email")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UserOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.emergencyContactName ? data.emergencyContactName : "N/A"} </span>
                                            <span className="decription-title">{t("text_emergency_contact_name")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <PhoneOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.emergencyContactNumber ? data.emergencyContactNumber : "N/A"} </span>
                                            <span className="decription-title">{t("text_emergency_contact_number")}</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                        <Card title={t("text_education_information")} bordered={false} className="employee-form title-font" style={{ marginBottom: 32 }}>
                            <Row gutter={[8, 40]} id="employee-certification-image-grid">
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_national_education")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table">
                                        <Table
                                            rowKey={() => `educations${Date.now() + Math.random()}`}
                                            dataSource={data.educations}
                                            columns={[
                                                {
                                                    title: t("text_institute"),
                                                    dataIndex: "institute",
                                                    key: "institute",
                                                    render: (institute) => institute ? institute : "N/A"
                                                },
                                                {
                                                    title: t("text_degree"),
                                                    dataIndex: "degree",
                                                    key: "degree",
                                                    render: (degree) => degree ? degree : "N/A"
                                                },
                                                {
                                                    title: t("text_date_s"),
                                                    dataIndex: "date",
                                                    key: "date",
                                                    render: (date) => date ? date : "N/A"
                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_short_course_certification")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table">
                                        <Table
                                            rowKey={() => `certifications${Date.now() + Math.random()}`}
                                            dataSource={data.certifications}
                                            columns={[
                                                {
                                                    title: t("text_title"),
                                                    dataIndex: "title",
                                                    key: "title",
                                                    render: (title) => title ? title : "N/A"
                                                },
                                                {
                                                    title: t("text_certifying_authority"),
                                                    dataIndex: "authority",
                                                    key: "authority",
                                                    render: (authority) => authority ? authority : "N/A"
                                                },
                                                {
                                                    title: t("text_date_s"),
                                                    dataIndex: "date",
                                                    key: "date",
                                                    render: (date) => date ? date : "N/A"
                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_attachment_of_education_certificate")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                {
                                    employeeCertifications.map((value, index) => {
                                        return (
                                            <Col sm={24} md={12} lg={8} xl={6} xxl={4} key={index}>
                                                <div className="certification-image-box">
                                                    <div className="certification-image-sub-box">
                                                        <div className="certification-image-sub-box-1">
                                                            <img
                                                                src={`${getHostURl()}/public/uploads/${Util.getInstance().getClientId()}/certificates/${id}/${value}`}
                                                                style={{ height: "90%", width: "95%", objectFit: "cover" }}
                                                                alt={"certifications"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })
                                }
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_languages")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table">
                                        <Table
                                            rowKey={() => `languages${Date.now() + Math.random()}`}
                                            dataSource={data.languages}
                                            columns={[
                                                {
                                                    title: t("text_language"),
                                                    dataIndex: "title",
                                                    key: "title",
                                                    render: (title) => title ? title : "N/A"

                                                },
                                                {
                                                    title: t("text_proficiency"),
                                                    dataIndex: "proficiency",
                                                    key: "proficiency",
                                                    render: (proficiency) => proficiency ? proficiency : "N/A"
                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_skills")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table">
                                        <Table
                                            rowKey={() => `skills${Date.now() + Math.random()}`}
                                            dataSource={data.skills}
                                            columns={[
                                                {
                                                    title: t("text_title"),
                                                    dataIndex: "title",
                                                    key: "title",
                                                    render: (title) => title ? title : "N/A"
                                                },
                                                {
                                                    title: t("text_level"),
                                                    dataIndex: "level",
                                                    key: "level",
                                                    render: (level) => level ? level : "N/A"
                                                },

                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                        <Card title={t("text_job_profile")} bordered={false} className="employee-form title-font" style={{ marginBottom: 32 }}>
                            <Row gutter={[8, 40]} >
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.supervisor?.name ? data.supervisor.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_1st_line_manager")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.projectManager?.name ? data.projectManager.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_2nd_line_manager")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.headOfDepartment?.name ? data.headOfDepartment.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_3rd_line_manager")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.fourthLineManager?.name ? data.fourthLineManager.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_4th_line_manager")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.fifthLineManager?.name ? data.fifthLineManager.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_5th_line_manager")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.position ? data.position : "N/A"} </span>
                                            <span className="decription-title">{t("text_position")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.jobGrade?.name ? data.jobGrade.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_job_grade")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.step ? data.step : "N/A"} </span>
                                            <span className="decription-title">{t("text_step")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.jobLevel?.name ? data.jobLevel.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_job_level")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.joinDate ? moment(data.joinDate).format("DD/MM/YYYY") : "N/A"} </span>
                                            <span className="decription-title">{t("text_date_of_employment")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.probationExpiredDate ? moment(data.probationExpiredDate).format("DD/MM/YYYY") : "N/A"}</span>
                                            <span className="decription-title">{t("text_probation_expired_date")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <FlagOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.employeeType === "NATIONAL" ? "National" : data.employeeType === "INTERNATIONAL" ? "International" : "N/A"} </span>
                                            <span className="decription-title">{t("text_employee_type")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <TeamOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.team?.name ? data.team.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_team")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ApartmentOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.department?.name ? data.department.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_department_programme")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <FileDoneOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.dutyStation ? data.dutyStation : "N/A"}</span>
                                            <span className="decription-title">{t("text_duty_station")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <FileSyncOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.contractType === Enum.CONTRACT_TYPE.UDC ? t("text_udc") : data.contractType === Enum.CONTRACT_TYPE.FDC ? t("text_fdc") : data.contractType === Enum.CONTRACT_TYPE.VOLUNTEER ? t("text_volunteer") : data.contractType === Enum.CONTRACT_TYPE.CONSULTANT ? t("text_consultant") : data.contractType === Enum.CONTRACT_TYPE.VOLUNTEER ? t("text_volunteer") : data.contractType === Enum.CONTRACT_TYPE.INTERNSHIP ? t("text_internship") : "N/A"} </span>
                                            <span className="decription-title">{t("text_contract_type")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ProfileOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.workingDay === "MTOF" ? "Working day (M-F)" : data.workingDay === "OPERATION_CALENDAR" ? "Operations Calendar" : "N/A"}</span>
                                            <span className="decription-title">{t("text_working_day")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <InteractionOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.status === 1 ? t("text_active") : data.status === 0 ? t("text_resigned") : "N/A"} </span>
                                            <span className="decription-title">{t("text_employment_status")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CodeOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.activityCode ? data.activityCode : "N/A"} </span>
                                            <span className="decription-title">{t("text_activity_code")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <UserOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.user?.role?.name ? data.user.role.name : "N/A"} </span>
                                            <span className="decription-title">{t("text_role")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_denors_budget_allocation")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table">
                                        <Table
                                            rowKey={() => `budgetAllocations${Date.now() + Math.random()}`}
                                            dataSource={data.budgetAllocations}
                                            columns={[
                                                {
                                                    title: t("text_project_name_code"),
                                                    dataIndex: "project",
                                                    key: "project",
                                                    render: project => project ? project : "N/A"
                                                },
                                                {
                                                    title: t("text_sub_project_code"),
                                                    dataIndex: "subProject",
                                                    key: "subProject",
                                                    render: subProject => subProject ? subProject : "N/A"
                                                },
                                                {
                                                    title: t("text_percentage_of_allocate"),
                                                    dataIndex: "percentage",
                                                    key: "percentage",
                                                    align: "center",
                                                    render: percentage => percentage ? `${percentage}%` : "N/A"
                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_contract_termination_notice_period")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ControlOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.isNoticeTerminate === 1 ? "Yes" : data.isNoticeTerminate === 0 ? "No" : "N/A"} </span>
                                            <span className="decription-title">{t("text_notice_of_termination")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <CalendarOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.noticePeriodType ? data.noticePeriodType : "N/A"} </span>
                                            <span className="decription-title">{t("text_short_absent_notice_period")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ContainerOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.terminationBenefit === 1 ? "Yes" : data.terminationBenefit === 0 ? "No" : "N/A"}</span>
                                            <span className="decription-title">{t("text_termination_benefit")}</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                        <Card title={t("text_compensation_benefit")} bordered={false} className="employee-form title-font" style={{ marginBottom: 32 }}>
                            <Row gutter={[8, 40]} >
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <DollarCircleOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.basicSalary ? parseFloat(data.basicSalary).toFixed(2) : "N/A"} </span>
                                            <span className="decription-title">{t("text_basic_salary")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            {data.pensionFundType === "PERCENTAGE" ? <PercentageOutlined className="personal-icon-font" /> : <DollarCircleOutlined className="personal-icon-font" />}
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.pensionFund ? parseFloat(data.pensionFund).toFixed(2) : "N/A"} </span>
                                            <span className="decription-title">{t("text_pension_fund")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            {data.providentFundType === "PERCENTAGE" ? <PercentageOutlined className="personal-icon-font" /> : <DollarCircleOutlined className="personal-icon-font" />}
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.providentFund ? parseFloat(data.providentFund).toFixed(2) : "N/A"} </span>
                                            <span className="decription-title">{t("text_providend_fund")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <MacCommandOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.insurance ? data.insurance : "N/A"} </span>
                                            <span className="decription-title">{t("text_insurance")}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <ScheduleOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.annualSalary === 1 ? "Yes" : data.annualSalary === 0 ? "No" : "N/A"}</span>
                                            <span className="decription-title">{"13th Month Salary"}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="item-layout">
                                        <div className="personal-icon-layout">
                                            <FileImageOutlined className="personal-icon-font" />
                                        </div>
                                        <div style={{ marginLeft: 14.29, display: "flex", flexDirection: "column" }}>
                                            <span className="decription">{data.seniority ? "Seniority" : data.severancePay ? "Severance Pay" : "N/A"} </span>
                                            <span className="decription-title">{"Seniority/Severance Pay"}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <div id="employee-profile-table">
                                        <Table
                                            rowKey={() => `benifits${Date.now() + Math.random()}`}
                                            dataSource={data.employeeBenefits}
                                            columns={[
                                                {
                                                    title: t("text_benefit"),
                                                    dataIndex: "payrollItemId",
                                                    key: "payrollItemId",
                                                    render: (payrollItemId, record) => record.payrollItem?.title
                                                },
                                                {
                                                    title: t("text_amount"),
                                                    dataIndex: "amount",
                                                    key: "amount",
                                                    render: (amount) => amount ? parseInt(amount).toFixed(2) : "N/A"
                                                },
                                                {
                                                    title: t("text_tax_on_salary"),
                                                    dataIndex: "isTaxable",
                                                    key: "isTaxable",
                                                    align: "center",
                                                    render: (isTaxable) => isTaxable ? <CheckCircleOutlined style={{ color: "#1D8747" }} /> : null
                                                },
                                                {
                                                    title: t("text_offered_tax_by"),
                                                    dataIndex: "offeredBy",
                                                    key: "offeredBy",
                                                    render: (offeredBy) => offeredBy === "ORGANIZATION" ? "Organization" : "Employee"

                                                },
                                            ]}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: 15, padding: 0, height: 45 }}>
                                    <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{t("text_attachment_of_benefit_information")}</p>
                                    <Divider style={{ margin: "6px 0px 25px 0px" }} />
                                </Col>
                                {
                                    employeeBenefits.map((value, index) => {
                                        return (
                                            <Col sm={24} md={12} lg={8} xl={6} xxl={4} key={index}>
                                                <div className="certification-image-box">
                                                    <div className="certification-image-sub-box">
                                                        <div className="certification-image-sub-box-1">
                                                            <img
                                                                src={`${getHostURl()}/public/uploads/${Util.getInstance().getClientId()}/benefits/${id}/${value}`}
                                                                style={{ height: "90%", width: "95%", objectFit: "cover" }}
                                                                alt={"certifications"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })
                                }
                            </Row>
                        </Card>
                    </>
                }
                {
                    switchTopFilter === "History" &&
                    <>
                        <div className="card-layout" style={{ marginBottom: 32 }}>
                            <Row style={{ height: "100%", width: "100%" }} >
                                <Col span={24}>

                                    <Tabs
                                        style={{ margin: "0 33px" }}
                                        onChange={onChangeHistory}
                                    >
                                        <TabPane tab={<span style={{ fontWeight: 500, fontSize: 17, display: "flex", justifyContent: "center", alignItems: "center" }}><DollarCircleOutlined /><span>Gross Salary</span></span>} key={"gross-salary"} >
                                            <div id="employee-profile-table" >
                                                <Table
                                                    rowKey={() => `Gross Salary${Date.now() + Math.random()}`}
                                                    dataSource={employeeGrossSalary}
                                                    loading={loadingHistory}
                                                    columns={[
                                                        {
                                                            title: "Last Modified",
                                                            dataIndex: "date",
                                                            height: 60,
                                                            key: "date",
                                                            render: (date) => date ? moment(date).format("DD/MM/YYYY") : "N/A"
                                                        },
                                                        {
                                                            title: "Modified By",
                                                            dataIndex: "user",
                                                            key: "user"
                                                        },
                                                        {
                                                            title: "Amount",
                                                            dataIndex: "currentValue",
                                                            key: "currentValue",
                                                            render: (currentValue) => currentValue ? `$${parseFloat(currentValue).toFixed(2)}` : "N/A"
                                                        }
                                                    ]}
                                                    pagination={false}
                                                />
                                            </div>
                                        </TabPane>
                                        <TabPane tab={<span style={{ fontWeight: 500, fontSize: 17, display: "flex", justifyContent: "center", alignItems: "center" }}><DollarCircleOutlined /><span>Pension Fund</span></span>} key={"pension-fund"} >
                                            <div id="employee-profile-table" >
                                                <Table
                                                    rowKey={() => `Pension Fund${Date.now() + Math.random()}`}
                                                    dataSource={employeePensionFund}
                                                    columns={[
                                                        {
                                                            title: "Last Modified",
                                                            dataIndex: "date",
                                                            height: 60,
                                                            key: "date",
                                                            render: (date) => date ? moment(date).format("DD/MM/YYYY") : "N/A"
                                                        },
                                                        {
                                                            title: "Modified By",
                                                            dataIndex: "user",
                                                            key: "user"
                                                        },
                                                        {
                                                            title: "Amount",
                                                            dataIndex: "currentValue",
                                                            key: "currentValue",
                                                            render: (currentValue) => currentValue ? `$${parseFloat(currentValue).toFixed(2)}` : "N/A"
                                                        }
                                                    ]}
                                                    loading={loadingHistory}
                                                    pagination={false}
                                                />
                                            </div>
                                        </TabPane>
                                        <TabPane tab={<span style={{ fontWeight: 500, fontSize: 17, display: "flex", justifyContent: "center", alignItems: "center" }}><DollarCircleOutlined /><span>Provident Fund</span></span>} key={"provident-fund"} >
                                            <div id="employee-profile-table" >
                                                <Table
                                                    rowKey={() => `Provident Fund${Date.now() + Math.random()}`}
                                                    dataSource={employeeProvidentFund}
                                                    columns={[
                                                        {
                                                            title: "Last Modified",
                                                            dataIndex: "date",
                                                            height: 60,
                                                            key: "date",
                                                            render: (date) => date ? moment(date).format("DD/MM/YYYY") : "N/A"
                                                        },
                                                        {
                                                            title: "Modified By",
                                                            dataIndex: "user",
                                                            key: "user"
                                                        },
                                                        {
                                                            title: "Amount",
                                                            dataIndex: "currentValue",
                                                            key: "currentValue",
                                                            render: (currentValue) => currentValue ? `$${parseFloat(currentValue).toFixed(2)}` : "N/A"
                                                        }
                                                    ]}
                                                    loading={loadingHistory}
                                                    pagination={false}
                                                />
                                            </div>
                                        </TabPane>
                                        <TabPane tab={<span style={{ fontWeight: 500, fontSize: 17, display: "flex", justifyContent: "center", alignItems: "center" }}><ApartmentOutlined /><span>Position</span></span>} key={"position"} >
                                            <div id="employee-profile-table" >
                                                <Table
                                                    rowKey={() => `Position${Date.now() + Math.random()}`}
                                                    dataSource={employeePosition}
                                                    columns={[
                                                        {
                                                            title: "Last Modified",
                                                            dataIndex: "date",
                                                            height: 60,
                                                            key: "date",
                                                            render: (date) => date ? moment(date).format("DD/MM/YYYY") : "N/A"
                                                        },
                                                        {
                                                            title: "Modified By",
                                                            dataIndex: "user",
                                                            key: "user"
                                                        },
                                                        {
                                                            title: "Position",
                                                            dataIndex: "currentValue",
                                                            key: "currentValue",
                                                            render: (currentValue) => currentValue ? currentValue : "N/A"
                                                        }
                                                    ]}
                                                    loading={loadingHistory}
                                                    pagination={false}
                                                />
                                            </div>
                                        </TabPane>
                                        <TabPane tab={<span style={{ fontWeight: 500, fontSize: 17, display: "flex", justifyContent: "center", alignItems: "center" }}><ClusterOutlined /><span>Job Grade</span></span>} key={"job-grade"} >
                                            <div id="employee-profile-table" >
                                                <Table
                                                    rowKey={() => `Job Grade${Date.now() + Math.random()}`}
                                                    dataSource={employeeJobGrade}
                                                    columns={[
                                                        {
                                                            title: "Last Modified",
                                                            dataIndex: "date",
                                                            height: 60,
                                                            key: "date",
                                                            render: (date) => date ? moment(date).format("DD/MM/YYYY") : "N/A"
                                                        },
                                                        {
                                                            title: "Modified By",
                                                            dataIndex: "user",
                                                            key: "user"
                                                        },
                                                        {
                                                            title: "Job Grade",
                                                            dataIndex: "currentValue",
                                                            key: "currentValue",
                                                            render: (currentValue) => currentValue ? currentValue : "N/A"
                                                        }
                                                    ]}
                                                    loading={loadingHistory}
                                                    pagination={false}
                                                />
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                </Col>
                            </Row>
                        </div>

                    </>
                }
                {
                    switchTopFilter === "Leave-Balance" &&
                    <>
                        <div className="card-layout" style={{ marginBottom: 32 }}>
                            <Row style={{ height: "100%", width: "100%" }} >
                                <Col span={24}>
                                    <div id="employee-profile-table" >
                                        <Table
                                            rowKey={() => `LeaveBalance${Date.now() + Math.random()}`}
                                            style={{ margin: "32px 33px 0px 33px" }}
                                            dataSource={employeeLeave}
                                            columns={[
                                                {
                                                    title: "Leave Type",
                                                    dataIndex: "name",
                                                    key: "name",
                                                    render: (name) => name
                                                },
                                                {
                                                    title: "Entitlement",
                                                    dataIndex: "entilement",
                                                    key: "entilement",
                                                    render: (entilement, record) => {
                                                        return getLeaveTypeName(record.type, entilement, "entilement");
                                                    }
                                                },
                                                {
                                                    title: "Carry Forward",
                                                    dataIndex: "carryForward",
                                                    height: 60,
                                                    key: "carryForward",
                                                    render: (carryForward, record) => {
                                                        return getLeaveTypeName(record.type, carryForward);
                                                    }
                                                },
                                                {
                                                    title: "Additional",
                                                    dataIndex: "additional",
                                                    key: "additional",
                                                    render: (additional, record) => {
                                                        return getLeaveTypeName(record.type, additional, false);
                                                    }
                                                },
                                                {
                                                    title: "Taken",
                                                    dataIndex: "taken",
                                                    height: 60,
                                                    key: "taken",
                                                    render: (taken, record) => {
                                                        return getLeaveTypeName(record.type, taken, "taken");
                                                    }
                                                },
                                                {
                                                    title: "Balance",
                                                    dataIndex: "leaveBalance",
                                                    key: "leaveBalance",
                                                    render: (leaveBalance, record) => {
                                                        return getLeaveTypeName(record.type, leaveBalance, "balance");
                                                    }
                                                }
                                            ]}
                                            loading={loadingLeave}
                                            pagination={false}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </>
                }
            </div>
        </Spin>
    );
};
export default ViewProfile;